/* eslint-disable react-hooks/exhaustive-deps */
// wijmo

// react
import {
  Container,
  Row,
  Col,
  Card,
  Collapse,
  Button,
  Form,
} from "react-bootstrap"
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."

// others
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import queryString from "query-string"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import dateUtil from "../../../ts/util/dateUtil"

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import DateInput from "../../../components/InputWrapper/DateInput"
import { RootState } from "../../../globalStore/rootreducer"
import TextInput from "../../../components/InputWrapper/TextInput"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"

import Spinner from "../../../components/Spinner"

import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import {
  TZyutyuHaisyaListGetReq,
  TZyutyuHaisyaListGetReqInner,
  TZyutyuHaisyaListGetRes,
} from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import ZyutyuHaisyaService from "../../../service/order/zyutyuHaisya/zyutyuHaisyaService"
import { 区分分類コード } from "../../../constant/enum/codes"
import { e検索日種別, T検索日種別コード } from "../../../constant/enum/frontend"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import {
  T検索日ComboboxItem,
  T表示用検索条件,
  T表示用検索条件共通部,
} from "../ZyutyuHaisyaList/TZyutyuHaisyaList"
import CONSTANT from "../../../constant"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import { ZyutyuHaisyaTableProvider } from "./ZyutyuHaisyaTableContext"
import ZyutyuHaisyaTableGrid from "./ZyutyuHaisyaTableGrid"

const 検索日: T検索日ComboboxItem[] = [
  { name: "積日", value: "1" } as const,
  { name: "卸日", value: "2" } as const,
]

/**
 * 配車表
 * @returns
 */
const ZyutyuHaisyaTable = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch: AppDispatch = useDispatch()

  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  const [accordionController, setAccordionController] = useState(true)

  //TODO:ページ名称確定必須
  let gridId = "ZyutyuHaisyaTable_GridId"

  //#region [state]

  // 画面共通
  const [isSearching, setIsSearching] = useState(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [displaySearchCondition, setDisplaySearchCondition] =
    useState<T表示用検索条件<T検索日種別コード>>()

  const [preSearchCondition, setPreSearchCondition] =
    useState<TZyutyuHaisyaListGetReq<T検索日種別コード>>()

  const [searchResult, setSearchResult] = useState<TZyutyuHaisyaListGetRes[]>()

  //１列目
  const [検索日コード, set検索日コード] = useState<"1" | "2" | null>()
  const [, set検索日] = useState<string | null>()
  const [検索日ItemSource, set検索日ItemSource] =
    useState<T検索日ComboboxItem[]>()
  const [検索日From, set検索日From] = useState<string | null | undefined>(
    翌営業日
  )
  const [検索日To, set検索日To] = useState<string | null | undefined>(翌営業日)

  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [付替区分コード, set付替区分コード] = useState<string | null>()

  const [運行部所コード, set運行部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)

  //２列目
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()

  const [表示順区分コード, set表示順区分コード] = useState<string | null>()

  const [isInvalid受注部所コード, setIsInvalid受注部所コード] = useState(false)
  //#endregion

  //#region [comboboxState]
  // 検索日
  const [検索日ComboBox, set検索日ComboBox] = useState<TWijmoComboBox<
    T検索日ComboboxItem["value"],
    T検索日ComboboxItem
  > | null>(null)
  const [検索日IsLoadEnded, set検索日IsLoadEnded] = useState<boolean>(false)

  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)

  // 付替区分
  const [付替区分ComboBox, set付替区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [付替区分isLoadEnded, set付替区分isLoadEnded] = useState<boolean>(false)

  // 運行場所
  const [運行部所ComboBox, set運行部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [運行部所isLoadEnded, set運行部所isLoadEnded] = useState<boolean>(false)

  // 表示順
  const [表示順区分ComboBox, set表示順区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [表示順区分isLoadEnded, set表示順区分isLoadEnded] =
    useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  // リストア制御用フラグ
  const [is荷主検索Modal, setIs荷主検索Modal] = useState<boolean>(false)

  //#endregion

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set検索日ItemSource(検索日)
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 受注部所isLoadEnded) {
      let querySearchCondition:
        | TZyutyuHaisyaListGetReq<T検索日種別コード>
        | undefined = undefined
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        querySearchCondition = queryParse()
        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
        // リストア中フラグON
        setIsRestoreSearching(true)
      } else {
        set受注部所コード(userInfo.部所コード)
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 受注部所isLoadEnded])

  //#endregion

  //#region [method]

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: Partial<
      TZyutyuHaisyaListGetReq<"1"> &
        TZyutyuHaisyaListGetReq<"2"> &
        TZyutyuHaisyaListGetReq<"3">
    > = queryString.parse(location.search)
    set荷主コード(query.荷主コード)
    set荷主名(query.荷主名)
    // 検索日変更用
    if (query.積日From || query.積日To) {
      set検索日コード(e検索日種別.積日)
      set検索日From(query.積日From)
      set検索日To(query.積日To)
    } else if (query.卸日From || query.卸日To) {
      set検索日コード(e検索日種別.卸日)
      set検索日From(query.卸日From)
      set検索日To(query.卸日To)
    }
    set受注部所コード(query.受注部所コード ?? userInfo.部所コード ?? "")
    set運行部所コード(query.運行部所コード ?? "")
    set付替区分コード(query.運行部所コード ?? "")
    set表示順区分コード(query.表示順区分コード ?? "")
    set荷主コード(query.荷主コード ?? "")
    set荷主名(query.荷主名 ?? "")

    return query as TZyutyuHaisyaListGetReq<T検索日種別コード>
  }

  /**
   * 検索
   */
  const search = async (
    searchCondition?: TZyutyuHaisyaListGetReq<T検索日種別コード>
  ) => {
    //遷移の制御確認
    if (isPrompt.current) {
      if (window.confirm(CONSTANT.MESSAGES.BROWSER_BACK)) {
        isPrompt.current = false
      } else {
        return
      }
    }
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition:
      | TZyutyuHaisyaListGetReq<T検索日種別コード>
      | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return
    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    // TODO:検索処理導入
    try {
      const service = new ZyutyuHaisyaService()
      const res = await service.getList(currentSearchCondition)
      setSearchResult([...res.data])
      setPreSearchCondition(currentSearchCondition)
      // QueryStringに検索条件を反映
      pageHelper.pushQuery(history, location, currentSearchCondition)
    } catch (error) {
      dispatch(setAlerts(error))
      setIsSearching(false)
    } finally {
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TZyutyuHaisyaListGetReq<T検索日種別コード> | undefined => {
    let 共通検索条件: TZyutyuHaisyaListGetReqInner = {
      検索日From: 検索日From ?? undefined,
      検索日To: 検索日To ?? undefined,
      受注部所コード: 受注部所コード ?? "",
      運行部所コード: 運行部所コード ?? undefined,
      付替区分コード: 付替区分コード ?? undefined,
      表示順区分コード: 表示順区分コード ?? undefined,
      荷主コード,
      荷主名,
    }
    switch (検索日コード) {
      case e検索日種別.積日:
        let 検索条件1: TZyutyuHaisyaListGetReq<"1"> = {
          ...共通検索条件,
          積日From: 検索日From ?? "",
          積日To: 検索日To ?? "",
        }
        return 検索条件1
      case e検索日種別.卸日:
        let 検索条件2: TZyutyuHaisyaListGetReq<"2"> = {
          ...共通検索条件,
          卸日From: 検索日From ?? "",
          卸日To: 検索日To ?? "",
        }
        return 検索条件2
      default:
        break
    }
  }

  /**
   * 表示用検索条件作成
   * @param queryString
   */
  const createDisplaySearchCondition = (
    searchCondition: TZyutyuHaisyaListGetReq<T検索日種別コード>
  ): T表示用検索条件<T検索日種別コード> | undefined => {
    let 表示用検索条件共通部: T表示用検索条件共通部 = {
      受注部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.受注部所コード
      )?.部所名,
      運行部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.運行部所コード
      )?.部所名,
      付替区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.付替区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.付替区分
      )?.名称1,
      配車状態区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.配車状態区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.配車状態区分
      )?.名称1,

      荷主コード: searchCondition.荷主コード,
      荷主名: searchCondition.荷主名,
      積地コード: searchCondition.積地コード,
      積地社名: searchCondition.積地社名,
      積地地名: searchCondition.積地地名,
      卸地コード: searchCondition.卸地コード,
      卸地社名: searchCondition.卸地社名,
      卸地地名: searchCondition.卸地地名,
      品コード: searchCondition.品コード,
      品名: searchCondition.品名,
      車番: searchCondition.車番,
      車種区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.車種区分コード &&
          i.分類コード === 区分分類コード.車輌.車種区分
      )?.名称1,
      乗務員: searchCondition.乗務員,
      傭車あり: searchCondition.傭車会社あり対象フラグ === 1,
      荷主依頼番号: searchCondition.荷主依頼番号,
      請求額確認区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.請求額確認区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.請求支払確認区分
      )?.名称1,
      表示順区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.表示順区分コード &&
          i.分類コード ===
            区分分類コード.受注配車_請求支払.受注配車入力表示順区分
      )?.名称1,
    }
    switch (検索日コード) {
      case e検索日種別.積日: {
        const sc = searchCondition as TZyutyuHaisyaListGetReq<"1">
        let 検索条件: T表示用検索条件<"1"> = {
          積日From: dateUtil.format(sc.積日From) ?? "",
          積日To: dateUtil.format(sc.積日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件
      }
      case e検索日種別.卸日: {
        const sc = searchCondition as TZyutyuHaisyaListGetReq<"2">
        let 検索条件: T表示用検索条件<"2"> = {
          卸日From: dateUtil.format(sc.卸日From) ?? "",
          卸日To: dateUtil.format(sc.卸日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件
      }
      default:
        break
    }
  }

  /**
   *
   * @param 荷主コード
   * @returns
   */
  const set表紙 = async (荷主コード: string) => {
    try {
      if (荷主コード == null || 荷主コード === "") {
        return
      }
      const 荷主res = await new NinusiService().getList({
        荷主コード: 荷主コード !== "" ? 荷主コード : undefined,
        完全一致フラグ: true,
      })

      const 荷主 = 荷主res.data[0]
      set荷主コード(荷主.荷主コード)
      set荷主名(荷主.荷主略称1)
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }
  //#endregion
  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">配車表一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-150rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body id="collapse-search-card-body">
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="w-10rem">
                                <ComboBox.Default
                                  placeholder="検索日"
                                  itemsSource={検索日ItemSource}
                                  isLoadEnded={検索日IsLoadEnded}
                                  selectedValue={検索日コード}
                                  isRequired={true}
                                  setSelectedValue={(v) => {
                                    set検索日コード(v)
                                  }}
                                  setText={set検索日}
                                  setIsLoadEnded={set検索日IsLoadEnded}
                                  ComboBox={検索日ComboBox}
                                  setComboBox={
                                    set検索日ComboBox
                                  }></ComboBox.Default>
                              </div>
                              <div className="w-13rem">
                                <DateInput
                                  id="検索日from"
                                  placeholder="検索日From"
                                  isRequired={true}
                                  has1DayButton={true}
                                  value={検索日From}
                                  defaultValue={翌営業日}
                                  setValue={(v) => {
                                    set検索日From(v)
                                  }}></DateInput>
                              </div>
                              <div className="w-13rem">
                                <DateInput
                                  id="検索日To"
                                  placeholder="検索日To"
                                  value={検索日To}
                                  isRequired={true}
                                  has1DayButton={true}
                                  defaultValue={翌営業日}
                                  setValue={(v) => {
                                    set検索日To(v)
                                  }}></DateInput>
                              </div>
                              <div className=""></div>
                              <ComboBox.Busyo
                                placeholder="受注部所"
                                isLoadEnded={受注部所isLoadEnded}
                                setIsLoadEnded={set受注部所isLoadEnded}
                                className={
                                  isInvalid受注部所コード
                                    ? "busyo-combo-box is-error"
                                    : "busyo-combo-box"
                                }
                                isAllSelect={false}
                                isEmpty={true}
                                isRequired={true}
                                itemsSource={部所ItemSource}
                                selectedValue={受注部所コード}
                                listFilter={(d) => d.運行部所フラグ === 1}
                                setSelectedValue={(v) => {
                                  set受注部所コード(v)
                                }}
                                ComboBox={受注部所ComboBox}
                                setComboBox={
                                  set受注部所ComboBox
                                }></ComboBox.Busyo>
                              <div className="w-10rem">
                                <ComboBox.Kubun
                                  placeholder="付替区分"
                                  分類コード={
                                    区分分類コード.受注配車_請求支払.付替区分
                                  }
                                  isAllSelect={true}
                                  isRequired={false}
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={付替区分isLoadEnded}
                                  setIsLoadEnded={set付替区分isLoadEnded}
                                  selectedValue={付替区分コード}
                                  setSelectedValue={(v) => {
                                    set付替区分コード(v)
                                  }}
                                  ComboBox={付替区分ComboBox}
                                  setComboBox={
                                    set付替区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                              <ComboBox.Busyo
                                placeholder="運行部所"
                                isLoadEnded={運行部所isLoadEnded}
                                setIsLoadEnded={set運行部所isLoadEnded}
                                isAllSelect={true}
                                isRequired={false}
                                itemsSource={部所ItemSource}
                                selectedValue={運行部所コード}
                                listFilter={(d) => d.運行部所フラグ === 1}
                                setSelectedValue={(v) => {
                                  set運行部所コード(v)
                                }}
                                ComboBox={運行部所ComboBox}
                                setComboBox={
                                  set運行部所ComboBox
                                }></ComboBox.Busyo>
                            </div>
                            <div className="search-condition-row">
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "6rem" }}
                                  id="荷主コード"
                                  name="荷主コード"
                                  value={荷主コード}
                                  onBlur={async (e) => {
                                    const v = e.currentTarget.value
                                    set表紙(v)
                                  }}
                                  setValue={(v) => {
                                    set荷主コード(v)
                                  }}
                                  maxLength={5}
                                  placeholder="荷主CD"
                                />
                                <button
                                  type="button"
                                  className="icon-button"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setIs荷主検索Modal(true)
                                  }}>
                                  <FontAwesomeIcon
                                    className="icon-button-inner"
                                    icon={faSearch}></FontAwesomeIcon>
                                </button>
                                <TextInput
                                  style={{ width: "16.1rem" }}
                                  id="荷主名"
                                  name="荷主名"
                                  value={荷主名}
                                  setValue={set荷主名}
                                  maxLength={100}
                                  placeholder="荷主名"
                                />
                              </div>
                              <div className="w-20rem">
                                <ComboBox.Kubun
                                  placeholder="表示順"
                                  分類コード={
                                    区分分類コード.受注配車_請求支払
                                      .受注配車入力表示順区分
                                  }
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={表示順区分isLoadEnded}
                                  isAllSelect={false}
                                  isRequired={false}
                                  setIsLoadEnded={set表示順区分isLoadEnded}
                                  selectedValue={表示順区分コード}
                                  setSelectedValue={(v) => {
                                    set表示順区分コード(v)
                                  }}
                                  ComboBox={表示順区分ComboBox}
                                  setComboBox={
                                    set表示順区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                            </div>

                            <Button
                              type="submit"
                              variant="primary"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                // 受注部所、未選択の場合検索させない
                                if (
                                  受注部所コード == null ||
                                  受注部所コード === ""
                                ) {
                                  setIsInvalid受注部所コード(true)
                                  dispatch(
                                    setWarningAlerts([
                                      "受注部所を選択してください",
                                    ])
                                  )
                                  return
                                } else {
                                  setIsInvalid受注部所コード(false)
                                }
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col xs={12}>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                    <ZyutyuHaisyaTableProvider
                      isSearching={{
                        state: isSearching,
                        setState: setIsSearching,
                      }}
                      isRestoreSearching={{
                        state: isRestoreSearching,
                        setState: setIsRestoreSearching,
                      }}
                      SearchResult={searchResult}
                      gridInitialized={{
                        state: gridInitialized,
                        setState: setGridInitialized,
                      }}
                      searchCondition={preSearchCondition}
                      searchDyType={{
                        state: 検索日コード,
                        setState: set検索日コード,
                      }}
                      searchDyFrom={{
                        state: 検索日From,
                        setState: set検索日From,
                      }}
                      searchDyTo={{
                        state: 検索日To,
                        setState: set検索日To,
                      }}
                      searchBusyoCd={{
                        state: 受注部所コード,
                        setState: set受注部所コード,
                      }}
                      search={search}
                      isPrompt={isPrompt}>
                      <ZyutyuHaisyaTableGrid
                        gridId={gridId}></ZyutyuHaisyaTableGrid>
                    </ZyutyuHaisyaTableProvider>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          set表紙(荷主.荷主コード)
        }}></NinusiSearchModal>
    </>
  )
}

export default ZyutyuHaisyaTable
